import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

const TRANSLATION_KEY = 'certified_digitalskillsauthority_org.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[] = [
    {
      id: 'about',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.about'),
      externalLink: 'https://www.digitalskillsauthority.org/global-digital-skills-awarding-body',
    },
    {
      id: 'partners',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.partners'),
      externalLink: 'https://www.digitalskillsauthority.org/partners',
    },
    {
      id: 'employers',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.employers'),
      externalLink: 'https://www.digitalskillsauthority.org/employers',
    },
    {
      id: 'exams',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.exams'),
      externalLink: 'https://www.digitalskillsauthority.org/exams',
    },
    {
      id: 'courses',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.courses'),
      externalLink:
        'https://www.digitalskillsauthority.org/digital-business-marketing-commerce-courses',
    },
    {
      id: 'certifications',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.certifications'),
      externalLink: 'https://www.digitalskillsauthority.org/certificate-online-business',
    },
  ];

  constructor(private readonly _language: AccredibleLanguageService) {}
}
